import { useQueryClient } from '@tanstack/react-query'

import {
  useNotesServicePostV1IndividualsByIndividualIdNotes,
} from '../client/queries'
import {
  useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey,
  useNotesServiceGetV1IndividualsByIndividualIdNotesKey,
} from '../client/queries/common'

export const useCreateNote = () => {
  const queryClient = useQueryClient()

  return useNotesServicePostV1IndividualsByIndividualIdNotes({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useNotesServiceGetV1IndividualsByIndividualIdNotesKey],
      })
      // A note created from an errand is attached to it server-side, so the errand's own `notes`
      // array — what the "Händelser" list is built from — is stale until the errands query
      // refetches. Invalidated unconditionally: the request body's `errandId` isn't visible here,
      // and an errands refetch is cheap next to getting the timeline wrong.
      queryClient.invalidateQueries({
        queryKey: [useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey],
      })
    },
  })
}
